import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-purchase-error',
  templateUrl: './purchase-error.component.html',
  styleUrls: ['./purchase-error.component.scss']
})
export class PurchaseErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
